export const BlockEventIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 17"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 1.3335V3.3335"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 1.3335V3.3335"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33398 6.06006H13.6673"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0007 15.3333C13.4734 15.3333 14.6673 14.1394 14.6673 12.6667C14.6673 11.1939 13.4734 10 12.0007 10C10.5279 10 9.33398 11.1939 9.33398 12.6667C9.33398 14.1394 10.5279 15.3333 12.0007 15.3333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7141 13.4067L11.3008 12"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7005 12.0132L11.2871 13.4265"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 5.66683V10.9068C13.5134 10.3535 12.8 10.0002 12 10.0002C10.5267 10.0002 9.33334 11.1935 9.33334 12.6668C9.33334 13.1668 9.47335 13.6402 9.72001 14.0402C9.86001 14.2802 10.04 14.4935 10.2467 14.6668H5.33334C3 14.6668 2 13.3335 2 11.3335V5.66683C2 3.66683 3 2.3335 5.33334 2.3335H10.6667C13 2.3335 14 3.66683 14 5.66683Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
